import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as WorkingPartServices from "../../../../services/WorkingPartService";
import * as UserServices from "../../../../services/UserServices";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import WorkingPartForm from "./dailyPartFormEdit.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";
import { getIsMangerSelector } from "../../../../store/selectors/authSelector";

const EditDailyPartFormContainer = ({
  isTechnical,
  uuid,
  onCancel,
  onSuccess,
  dailyUuid,
}) => {
  const isManager = useSelector(getIsMangerSelector);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [dailyPart, setDailyPart] = useState(null);
  const [employee, setEmployee] = useState(null);

  const setInitialValues = useCallback(async (data, data2) => {
    const dataFinal = {
      date: data.date,
    };
    setInitValues(dataFinal);
    setDailyPart(data);
    setEmployee(data2);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await WorkingPartServices.getDailyPart(uuid);
      if (result) {
        const result2 = await UserServices.listFilter({
          uuid: result.userUuid,
        });
        if (result2) {
          await setInitialValues(result, result2.docs[0]);
        }
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        const result = await WorkingPartServices.updateDateParts(values, uuid);

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.workingPart.messages.update.title");
            text = t("forms.workingPart.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.workingPart.messages.create.title");
            text = t("forms.workingPart.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.workingPart.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          onSuccess();
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  return (
    <WorkingPartForm
      isManager={isManager}
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onBack={onCancel}
      dailyPart={dailyPart}
      employee={employee}
    />
  );
};

EditDailyPartFormContainer.propTypes = {
  t: PropTypes.any,
};

export default EditDailyPartFormContainer;
